import { Phone } from 'lucide-react';

type Props = {
    readonly displayName: string | null | undefined;
    readonly phoneE164: string | null | undefined;
};

function getInitials(name: string): string {
    const tokens = name.trim().split(/\s+/).filter(Boolean);
    if (tokens.length === 0) {
        return '?';
    }
    const first = tokens[0] ?? '';
    if (tokens.length === 1) {
        return first.slice(0, 2).toUpperCase();
    }
    const last = tokens[tokens.length - 1] ?? first;
    return ((first[0] ?? '') + (last[0] ?? '')).toUpperCase();
}

function formatUsPhone(phone: string | null | undefined): string | null {
    if (!phone) {
        return null;
    }
    const match = phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
}

export function ContactCardPreview({ displayName, phoneE164 }: Props) {
    const safeName = (displayName ?? '').trim() || 'Phoebe';
    const initials = getInitials(safeName);
    const formattedPhone =
        formatUsPhone(phoneE164) ?? 'No Phoebe number configured';
    return (
        <div className="border-border bg-background min-w-0 rounded-2xl border p-4 shadow-sm sm:p-6">
            <p className="text-muted-foreground mb-4 text-xs font-medium tracking-wide uppercase">
                Contact card preview
            </p>
            <div className="flex flex-col items-center text-center">
                <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border border-gray-200 bg-white text-2xl font-semibold text-gray-700">
                    {initials}
                </div>
                <p className="mb-1 max-w-full text-lg font-semibold break-words text-gray-900">
                    {safeName}
                </p>
                <p className="text-sm text-gray-500">mobile</p>
                <div className="mt-4 flex w-full max-w-xs items-center justify-between rounded-lg bg-[#E9E9EB] px-4 py-3">
                    <div className="flex min-w-0 items-center gap-2 text-sm text-gray-900">
                        <Phone className="h-4 w-4 text-gray-600" />
                        <span className="min-w-0 break-words">
                            {formattedPhone}
                        </span>
                    </div>
                </div>
                <div className="mt-4 w-full max-w-xs divide-y divide-white/70 overflow-hidden rounded-lg bg-[#E9E9EB] text-left text-sm text-gray-900">
                    <div className="px-4 py-2.5">Share Contact</div>
                    <div className="px-4 py-2.5">Create New Contact</div>
                    <div className="px-4 py-2.5">Add to Existing Contact</div>
                </div>
            </div>
        </div>
    );
}
